import React from 'react';
import { HeroFullBlock } from '@cotyorg/ccx-organism-hero';
import { recyclingBaseCardoConfig } from './cardo.config';

export const RecyclingSection = () => (
  <div className="recycling-section">
    <HeroFullBlock
      heroStoreDataKey="recycling"
      isUnderlined={false}
      breakpointConfig={recyclingBaseCardoConfig}
    />
  </div>
);
